import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, ShieldCheck } from "lucide-react";
import thankyou from "@/i18n/thankyou_fr.json";

export const ThankYouPage = () => {
  useEffect(() => {
    document.title = "Merci — Vexorqa";
  }, []);

  return (
    <div data-testid="thank-you-page" className="min-h-screen bg-white flex flex-col">
      <header className="bg-[#0B1E36] text-white border-b border-slate-800">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <span className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center bg-emerald-600 text-white rounded-sm">
              <ShieldCheck className="h-4 w-4" />
            </span>
            <span className="font-semibold tracking-[0.18em] text-sm">VEXORQA</span>
          </span>
          <span className="text-[11px] uppercase tracking-widest text-emerald-300">
            {thankyou.badge}
          </span>
        </div>
      </header>

      <main className="flex-1">
        <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center">
          <span className="inline-flex h-16 w-16 items-center justify-center bg-emerald-100 border border-emerald-300 text-emerald-700 rounded-full">
            <CheckCircle2 className="h-8 w-8" strokeWidth={2.2} />
          </span>
          <h1
            data-testid="thank-you-title"
            className="mt-6 text-3xl sm:text-4xl font-bold tracking-tight text-[#0B1E36]"
            style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}
          >
            {thankyou.title}
          </h1>
          <p className="mt-5 text-base sm:text-lg text-slate-700 leading-relaxed">
            {thankyou.subtitle}
          </p>
        </section>

        <section className="bg-slate-50 border-y border-slate-200">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
            <h2 className="text-lg font-semibold text-slate-900">
              {thankyou.confirmation_title}
            </h2>
            <ol className="mt-6 space-y-4">
              {thankyou.steps.map((s, i) => (
                <li key={i} className="flex gap-4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center bg-[#0B1E36] text-emerald-300 font-mono text-sm rounded-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="text-sm text-slate-700 leading-relaxed">{s}</p>
                </li>
              ))}
            </ol>
            <p className="mt-8 text-xs text-slate-500 leading-relaxed border-l-2 border-emerald-600 pl-4">
              {thankyou.note}
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="thankyou-back-home"
            className="inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-6 py-3.5 rounded-sm"
          >
            <ArrowLeft className="h-4 w-4" /> {thankyou.cta_home}
          </Link>
          <Link
            to="/fr/privacy-policy"
            data-testid="thankyou-privacy-link"
            className="inline-flex items-center justify-center gap-2 border border-slate-300 hover:border-slate-500 text-slate-800 text-sm font-semibold px-6 py-3.5 rounded-sm"
          >
            {thankyou.cta_privacy}
          </Link>
        </section>
      </main>

      <footer className="bg-[#071426] text-slate-400 py-6">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center text-xs">
          {thankyou.footer_note}
        </div>
      </footer>
    </div>
  );
};

export default ThankYouPage;
